import jwt from 'jsonwebtoken';

import { store } from '../store';

import { isValidArray } from '../util/functions';
import { PerfilUsuario } from '../pages/constants';

class AuthService {
  acessToken() {
    const { token } = store.getState().auth;
    try {
      const decoded = jwt.decode(token);
      return {
        signed: true,
        exp: decoded.exp,
        usuario: decoded.usuario,
        token,
      };
    } catch (error) {
      return {
        signed: false,
        exp: 0,
        token: '',
      };
    }
  }

  getUsuario() {
    const { decodedToken } = store.getState().auth;

    try {
      return decodedToken.usuario;
    } catch (error) {
      return null;
    }
  }

  getConfiguracao() {
    const { decodedToken } = store.getState().auth;

    try {
      return decodedToken.configuracao;
    } catch (error) {
      return null;
    }
  }

  isPerfilGerente() {
    const perfil = this.getPerfilUsuario();
    if (
      perfil &&
      (perfil === PerfilUsuario.administrador || perfil === PerfilUsuario.gerente)
    ) {
      return true;
    }
    return false;
  }

  isPerfilGerenteSuporte() {
    const perfil = this.getPerfilUsuario();
    if (
      perfil &&
      (perfil === PerfilUsuario.administrador || perfil === PerfilUsuario.gerenteSuporte)
    ) {
      return true;
    }
    return false;
  }

  isPerfilGerenteProgramacao() {
    const perfil = this.getPerfilUsuario();
    if (
      perfil &&
      (perfil === PerfilUsuario.administrador || perfil === PerfilUsuario.gerenteProgramacao)
    ) {
      return true;
    }
    return false;
  }

  getPerfilUsuario() {
    const usuario = this.getUsuario();
    if (usuario) {
      return usuario.idUsuarioPerfil;
    }
    return '';
  }

  checkRoles(arrayNames) {
    const { decodedToken } = store.getState().auth;
    if (!decodedToken) {
      return false;
    }
    const { roles } = decodedToken;

    if (!isValidArray(arrayNames)) {
      arrayNames = arrayNames ? [arrayNames] : [];
    }

    if (arrayNames.length === 0) {
      return true;
    }

    let ret = false;

    arrayNames.forEach(e => {
      if (!roles || !Array.isArray(roles)) {
        return false;
      }
      if (roles.includes(e)) {
        ret = true;
        return true;
      }
    });

    return ret;
  }
}

export default new AuthService();
